import React, {useEffect, useMemo} from "react"
import {
    ConditionsI,
    ConditionType,
    getInitConditionsValue,
    passwordInputSymbols,
} from "./Interfaces"

export const useConditionsManage: (
    isPasswordInput: boolean,
    conditions: ConditionsI,
    setConditions: React.Dispatch<React.SetStateAction<ConditionsI>>,
    value?: string
) => void = (isPasswordInput, conditions, setConditions, value) => {
    const initConditionsValue = useMemo(getInitConditionsValue, [])

    useEffect(() => {
        if (isPasswordInput) {
            if (value) {
                if (passwordInputSymbols.some((symbol) => value.includes(symbol))) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.symbol]: {
                            ...s[ConditionType.symbol],
                            isAccept: true,
                        },
                    }))
                } else if (conditions[ConditionType.symbol].isAccept) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.symbol]: {
                            ...s[ConditionType.symbol],
                            isAccept: false,
                        },
                    }))
                }

                if (/[a-z]/.test(value)) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.lowercase]: {
                            ...s[ConditionType.lowercase],
                            isAccept: true,
                        },
                    }))
                } else if (conditions[ConditionType.lowercase].isAccept) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.lowercase]: {
                            ...s[ConditionType.lowercase],
                            isAccept: false,
                        },
                    }))
                }

                if (value.length >= 8) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.length]: {
                            ...s[ConditionType.length],
                            isAccept: true,
                        },
                    }))
                } else if (conditions[ConditionType.length].isAccept) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.length]: {
                            ...s[ConditionType.length],
                            isAccept: false,
                        },
                    }))
                }

                if (/[A-Z]/.test(value)) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.uppercase]: {
                            ...s[ConditionType.uppercase],
                            isAccept: true,
                        },
                    }))
                } else if (conditions[ConditionType.uppercase].isAccept) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.uppercase]: {
                            ...s[ConditionType.uppercase],
                            isAccept: false,
                        },
                    }))
                }

                if (/[0-9]/.test(value)) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.number]: {
                            ...s[ConditionType.number],
                            isAccept: true,
                        },
                    }))
                } else if (conditions[ConditionType.number].isAccept) {
                    setConditions((s) => ({
                        ...s,
                        [ConditionType.number]: {
                            ...s[ConditionType.number],
                            isAccept: false,
                        },
                    }))
                }
            } else {
                setConditions(initConditionsValue)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPasswordInput, value])
}
